import CourseCard from './CourseCard';
import './SearchResults.css';

export default function SearchResults({ query, results, onClear }) {
  if (!query) return null;

  return (
    <section id="search-results" className="search-results">
      <div className="container">
        <div className="search-results__header">
          <div className="search-results__info">
            <span className="search-results__tag-pill">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                <line x1="7" y1="7" x2="7.01" y2="7"/>
              </svg>
              {query}
            </span>
            <h2 className="section-title">
              {results.length > 0
                ? `${results.length} course${results.length !== 1 ? 's' : ''} found`
                : 'No courses found'}
            </h2>
          </div>
          <button className="search-results__clear" onClick={onClear} aria-label="Clear search">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
            Clear
          </button>
        </div>

        {results.length > 0 ? (
          <div className="search-results__grid">
            {results.map(course => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        ) : (
          <p className="search-results__empty">
            No courses match that topic yet — try a different term or browse the lists below.
          </p>
        )}
      </div>
    </section>
  );
}
